import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const NeroDiamantePage = ({ language, setLanguage, t }) => {
  if (!t) return <div className="container">Error: Translations not loaded</div>;

  return (
    <div className="app-page-container nero-page">
      <div className="content-wrapper">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        
        <Link to="/" className="back-btn premium-back">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {t.back || 'Back'}
        </Link>

        {/* Hero Section */}
        <div className="app-hero nero-hero">
          <div className="app-icon-section">
            <div className="nero-icon-container">
              <img
                src="/images/diamond.png"
                alt="Nero Diamante"
                className="app-hero-icon nero-icon"
                onError={(e) => { e.target.src = '/images/fallback.png'; }}
              />
              <div className="nero-icon-glow"></div>
            </div>
            <div className="app-info">
              <h1 className="app-title nero-title">{t.neroDiamanteTitle || 'Nero Diamante'}</h1>
              <div className="app-rating premium-rating">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="star gold-star">★</span>
                ))}
                <span className="rating-text premium-rating-text">5.0</span>
              </div>
              <p className="app-subtitle nero-subtitle">{t.neroDiamanteTagline || 'Interactive Digital Art'}</p>
              <div className="exclusivity-badge">
                <span className="badge-text">ONLY 1000 WILL EVER EXIST</span>
              </div>
            </div>
          </div>
          
          <div className="download-section premium-download">
            <div className="price-display">
              <span className="price-currency">$</span>
              <span className="price-amount">999</span>
              <span className="price-period">.99</span>
            </div>
            <a href="https://apps.apple.com/app/nero-diamante/id1234567890" className="download-button premium-ios">
              <div className="download-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
              </div>
              <div className="download-text">
                <span className="download-label">Available on</span>
                <span className="download-store">App Store</span>
              </div>
            </a>
            <div className="premium-notice">
              <span>🇸🇪 Crafted in Sweden</span>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="app-main-content nero-content">
          {/* About Section */}
          <div className="about-section nero-about">
            <h2 className="section-title premium-section-title">{t.aboutTitle || 'Digital Art Redefined'}</h2>
            <div className="about-text premium-text">
              <p>{t.aboutText1 || 'Nero Diamante represents the pinnacle of interactive digital art. Each piece is a unique work of art, limited to only 1000 pieces worldwide.'}</p>
              <p>{t.aboutText2 || 'Experience touch-responsive prismatic effects, authentic ownership documentation, and Swedish design excellence in every interaction.'}</p>
              <p>{t.aboutText3 || 'Join an exclusive community of digital art collectors who appreciate innovation, rarity, and artistic expression.'}</p>
            </div>
            
            <div className="features-showcase nero-features">
              {[
                { icon: '💎', title: t.features?.exclusivity || 'Ultimate Exclusivity', desc: 'Only 1000 will ever exist' },
                { icon: '✨', title: t.features?.interactive || 'Interactive Art', desc: 'Touch-responsive effects' },
                { icon: '📜', title: t.features?.certificate || 'Authenticity Certificate', desc: 'Verified ownership proof' },
                { icon: '🇸🇪', title: t.features?.craftsmanship || 'Swedish Craftsmanship', desc: 'Premium design heritage' },
              ].map((feature, i) => (
                <div key={i} className="feature-showcase-card nero-feature-card">
                  <div className="feature-showcase-icon nero-feature-icon">{feature.icon}</div>
                  <h3 className="feature-showcase-title nero-feature-title">{feature.title}</h3>
                  <p className="feature-showcase-desc nero-feature-desc">{feature.desc}</p>
                </div>
              ))}
            </div>

            {/* Scarcity Counter */}
            <div className="scarcity-section">
              <div className="scarcity-counter">
                <div className="counter-number">847</div>
                <div className="counter-label">REMAINING</div>
              </div>
              <div className="scarcity-text">
                <p>When all 1000 are claimed, no more will ever be created.</p>
                <p className="urgency-text">Secure your piece of digital art history.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="app-footer nero-footer">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">{t.ourApps || 'Home'}</Link>
              <Link to="/quitsnus">{t.quitSnusTitle || 'QuitSnus'}</Link>
              <Link to="/mrpiggy">{t.mrPiggyTitle || 'Mr Piggy'}</Link>
              <Link to="/quitsmoking">{t.quitSmokingTitle || 'QuitSmoking'}</Link>
            </div>
            <div className="footer-legal premium-legal">
              <Link to="/nero-diamante-privacy">{t.privacyPolicy || 'Privacy Policy'}</Link>
              <Link to="/nero-diamante-terms">{t.termsOfUse || 'Terms of Service'}</Link>
            </div>
            <div className="premium-footer-text">
              <p>Nero Diamante • Interactive Digital Art • Swedish Design Excellence</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default NeroDiamantePage;